export default __webpack_public_path__ + "static/media/icon-buss-traslado.6da112c8.svg";